import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { addDoc, collection, doc, getDoc, Timestamp } from "firebase/firestore";
import Swal from "sweetalert2";

import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    CircularProgress,
    Grid
} from "@mui/material";

function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [systemDetails, setSystemDetails] = useState({});

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
    });

    useEffect(() => {
        setSystemDetails({
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            language: navigator.language,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        });
    }, []);

    const login1 = async () => {

        if (!email || !password) {
            return Toast.fire({
                icon: "error",
                title: "Enter Email & Password"
            });
        }

        setLoading(true);

        try {

            await signInWithEmailAndPassword(auth, email, password);

            const user = auth.currentUser;

            if (user) {

                const docRef = doc(db, "users", user.uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists() && docSnap.data().role === "Accountant") {

                    await addDoc(collection(db, "logindetails"), {
                        uid: user.uid,
                        username: docSnap.data().name,
                        systemDetails,
                        createdTime: Timestamp.now()
                    });

                    Toast.fire({
                        icon: "success",
                        title: "Login Successful"
                    });

                    window.location.href = "/home";

                } else {

                    Toast.fire({
                        icon: "error",
                        title: "Access Denied"
                    });

                    auth.signOut();
                }

            }

        } catch (error) {

            Toast.fire({
                icon: "error",
                title: "Invalid Credentials"
            });

        } finally {
            setLoading(false);
        }

    };

    return (

        <Box sx={{
            height: "100vh",
            background: "#f5f7fb"
        }}>

            <Grid className="row" sx={{ height: "100%" }}>

                {/* LEFT SIDE BRAND SECTION */}

                <Grid
                    item
                    className="col-sm-6"
                    sx={{
                        background: "linear-gradient(135deg,#ff512f,#dd2476)",
                        color: "#fff",
                        display: { xs: "none", md: "flex" },
                        alignItems: "center",
                        justifyContent: "center",
                        p: 8,
                        position: "relative",
                        overflow: "hidden"
                    }}
                >

                    {/* abstract shapes */}

                    <Box sx={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        background: "rgba(255,255,255,0.15)",
                        borderRadius: "50%",
                        top: -150,
                        right: -150
                    }} />

                    <Box sx={{
                        position: "absolute",
                        width: 400,
                        height: 400,
                        background: "rgba(255,255,255,0.1)",
                        borderRadius: "50%",
                        bottom: -120,
                        left: -120
                    }} />

                    <Box sx={{ position: "relative", zIndex: 2, maxWidth: 500 }}>

                        <img src="/logo.jpeg" height={90} />

                        <Typography sx={{
                            fontSize: 42,
                            fontWeight: 800,
                            mt: 4,
                            lineHeight: 1.2
                        }}>
                            Mohan Mali
                            International School
                        </Typography>

                        <Typography sx={{
                            mt: 3,
                            fontSize: 18,
                            opacity: 0.9
                        }}>
                            Welcome to the Accountant Module
                        </Typography>

                    </Box>

                </Grid>


                {/* LOGIN SECTION */}

                <Grid
                    item
                    xs={12}
                    className="col-sm-6"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >

                    <Paper sx={{
                        width: 380,
                        p: 5,
                        borderRadius: 4,
                        boxShadow: "0 20px 60px rgba(0,0,0,0.15)"
                    }}>

                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            textAlign="center"
                            mb={1}
                        >
                            Login Portal
                        </Typography>

                        <Typography
                            textAlign="center"
                            sx={{ mb: 4, color: "#777" }}
                        >
                            Enter your credentials to continue
                        </Typography>

                        <TextField
                            fullWidth
                            label="Email Address"
                            size="small"
                            sx={{ mb: 2 }}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <TextField
                            fullWidth
                            label="Password"
                            type="password"
                            size="small"
                            sx={{ mb: 3 }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        <Button
                            variant="contained"
                            fullWidth
                            onClick={login1}
                            disabled={loading}
                            sx={{
                                py: 1.4,
                                fontWeight: "bold",
                                borderRadius: 2,
                                background: "linear-gradient(90deg,#ff512f,#dd2476)"
                            }}
                        >

                            {loading
                                ? <CircularProgress size={24} color="inherit" />
                                : "Login"}

                        </Button>

                        <Typography
                            variant="caption"
                            display="block"
                            textAlign="center"
                            sx={{ mt: 4, color: "#777" }}
                        >
                            © {new Date().getFullYear()} Mohan Mali International School
                        </Typography>

                    </Paper>

                </Grid>

            </Grid>

        </Box>

    );

}

export default Login;